module.exports = __webpack_public_path__ + "img/icon-xiaohongshu-black.64a1e55d.png";